import React from "react";
import Field from "../../Common/Field/Field";
import App from "../../../pages/report/multiSelect";
import Picky from "react-picky"
import "react-picky/dist/picky.css"

//process update form 
const BulkProcessUpdates = props => {
    return (
        <div className="col-md-12 text-center">
            {props.showForm && <span>
                <div className="col-md-12 d-flex justify-content-center">
                    <div className="col-md-3 px-2" style={{ zIndex: "1002" }}>
                        <label>Customer department</label>
                        <App
                            customerInfo={props.customerWithDepartment}
                            selectedCustomers={props.storeCustomerData}
                        />
                    </div>
                    <div className="col-md-2" style={{ zIndex: "1000" }}>
                        <label>ETA/ETD From</label>
                        <Field
                            inputType="date"
                            inputName="fromDate"
                            label="from Date"
                            value={props.fromDate}
                            onChange={props.updateState}
                            disabled={false}
                            className="Select-control"
                        />
                    </div>
                    <div className="col-md-2" >
                        <label>ETA/ETD To</label>
                        <Field
                            inputType="date"
                            inputName="toDate"
                            label="to Date"
                            value={props.toDate}
                            onChange={props.updateState}
                            disabled={false}
                            className="Select-control"
                        />
                        {/* </div> */}
                    </div>
                </div>
                <div className="col-md-12 d-flex justify-content-center p-1">
                    <div className="col-md-3" style={{ zIndex: "1000" }}>
                        <label>Process Type</label>
                        <Field
                            inputType="select"
                            inputName="processType"
                            value={props.processType}
                            options={props.processTypeOptions}
                            onChange={props.updateState}
                            disabled={false}
                            className="Select-control"
                        />
                    </div>
                    <div className="col-md-3" style={{ zIndex: "0" }}>
                        <label>Source of request</label>
                        <Field
                            inputType="select"
                            inputName="typeOfRequest"
                            value={props.typeOfRequest}
                            options={props.typeOfRequestOptions}
                            onChange={props.updateState}
                            disabled={false}
                            className="Select-control"
                        />
                    </div>
                    <div className="col-md-3" style={{ zIndex: "0" }}>
                        <label>Sample Type</label>
                        {/* <Field
                            inputType="select"
                            inputName="sampleType"
                            value={props.sampleType}
                            options={props.sampleTypeOptions}
                            onChange={props.updateState}
                            disabled={false}
                            className="Select-control"
                        /> */}
                        <Picky
                        value={props.arrayValue2}
                        options={props.sampleTypeOptions}
                        onChange={props.selectMultipleOption2}
                        open={false}
                        valueKey="value"
                        labelKey="label"
                        multiple={true}
                        includeSelectAll={true}
                        manySelectedPlaceholder={"%s selected"} 
                        allSelectedPlaceholder={"%s selected"}
                        includeFilter={true} 
                        dropdownHeight={300}
                        placeholder="Select a sample type" 
                        disabled={false}
                    />
                    </div>
                </div>
            </span>}
            {props.requestKey && !props.showForm && <div className="col-md-12 d-flex justify-content-center p-1">
                <div className="col-md-2" style={{ zIndex: "1000" }}>
                    <label>Update To</label>
                    <Field
                        inputType="select"
                        inputName="requestKey"
                        value={props.requestKey}
                        options={[{ label: "ETA", value: "ETA" }, { label: "STATUS", value: "status" }]}
                        onChange={(name, value) => props.updateState(name, value, false, "requestValue")}
                        disabled={false}
                        className="Select-control"
                    />
                </div>
                <div className="col-md-2" style={{ zIndex: "1000" }}>
                    <label>Update Value</label>
                    {
                        props.requestKey === "status" && <Field
                            inputType="select"
                            inputName="requestValue"
                            value={props.requestValue}
                            options={props.STATUS && props.STATUS.filter(x => x.value !== "PENDING") || []}
                            onChange={(name, value) => props.updateState(name, value, false)}
                            disabled={false}
                            className="Select-control"
                        /> || <Field
                            inputType="date"
                            inputName="requestValue"
                            value={props.requestValue}
                            onChange={(name, value) => props.updateState(name, value, false)}
                            disabled={false}
                            className="Select-control"
                        />
                    }

                </div>
                <div className="col-md-2 pt-4 d-flex align-items-center">
                    <button
                        class="primary"
                        onClick={props.saveProcessUpdates}
                    >
                        Save
                    </button>
                    <span className="px-2"></span>
                    <button
                        class="primary"
                        onClick={() => props.updateState("showForm", true)}
                    >
                        Reset
                    </button>
                </div>
            </div>}
        </div>
    );
};

export default BulkProcessUpdates;


// WEBPACK FOOTER //
// ./src/components/Report/forms/BulkProcessUpdates.js